import { fetchAPI } from "./baseApi";

// ============================================================
// WEBSITE STATS (Level 1 only)
// ============================================================

export async function getStatsSummary() {
  return fetchAPI("/stats/summary");
}

export async function getDailyStats(startDate = null, endDate = null) {
  const params = new URLSearchParams();
  if (startDate) params.append("startDate", startDate);
  if (endDate) params.append("endDate", endDate);

  const queryString = params.toString();
  return fetchAPI(`/stats/daily${queryString ? `?${queryString}` : ""}`);
}

export async function getMonthlyStats(year = null) {
  const params = new URLSearchParams();
  if (year) params.append("year", year);

  const queryString = params.toString();
  return fetchAPI(`/stats/monthly${queryString ? `?${queryString}` : ""}`);
}

export async function getYearlyStats() {
  return fetchAPI("/stats/yearly");
}

export async function getPageStats(startDate = null, endDate = null) {
  const params = new URLSearchParams();
  if (startDate) params.append("startDate", startDate);
  if (endDate) params.append("endDate", endDate);

  const queryString = params.toString();
  return fetchAPI(`/stats/pages${queryString ? `?${queryString}` : ""}`);
}

export async function exportStatsJson(startDate = null, endDate = null) {
  const params = new URLSearchParams();
  if (startDate) params.append("startDate", startDate);
  if (endDate) params.append("endDate", endDate);

  const baseUrl = process.env.REACT_APP_API_BASE_URL || "/api";
  const token = localStorage.getItem("adminToken");
  const url = `${baseUrl}/stats/export/json${params.toString() ? `?${params.toString()}` : ""}`;

  const response = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error("Failed to export stats");
  }

  const blob = await response.blob();
  const downloadUrl = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = downloadUrl;
  a.download = `website-stats-${new Date().toISOString().split("T")[0]}.json`;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(downloadUrl);
  document.body.removeChild(a);

  return { message: "Stats exported successfully" };
}
